<template>
  <div class="common-layout" v-if="$route.meta.keepAlive">
    <el-container class="container">
      <el-header style="height:1rem;padding-left: 0;">
        <keep-alive>
          <Header></Header>
        </keep-alive>
      </el-header>
      <el-container style="height: 4rem;">
        <el-container class="main-container">
          <el-main >
            <!--引入跳转路由-->
            <RouterView />
          </el-main>
          <!-- <el-footer>
            <keep-alive>
              <Footer></Footer>
            </keep-alive>
          </el-footer> -->
        </el-container>
      </el-container>
    </el-container>
  </div>
  <router-view v-if="!$route.meta.keepAlive"></router-view>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import LeftMenu from './components/LeftMenu.vue'
export default {
  components: {
    Header,
    // eslint-disable-next-line vue/no-unused-components
    LeftMenu,
    Footer
  },
  name: 'App',
}
</script>

<style>
html,
body {
  margin: 0;
  width: 100%;
  height: 100vh;
}

#app {
  height: 100vh;
  color: #3d3d3d;
}

.el-footer {
  padding-left: 0 !important;
  padding-right: 0 !important;
  height: 0.9rem!important;
}

.el-message__icon {
  font-size: 0.14rem !important;
}

.common-layout{
  height: 100vh;
}
.container{
  height: 100vh;
}

</style>




